import { render, staticRenderFns } from "./AddressBookInfo.vue?vue&type=template&id=f1c4bca8&scoped=true&"
import script from "./AddressBookInfo.vue?vue&type=script&lang=js&"
export * from "./AddressBookInfo.vue?vue&type=script&lang=js&"
import style0 from "./AddressBookInfo.vue?vue&type=style&index=0&id=f1c4bca8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1c4bca8",
  null
  
)

export default component.exports